<template>
    <div>
        <div class="mb-4 d-flex align-items-center">
            <div class="mb-2 text-center text-title" style="width:100%;"> {{title }}</div>
            <div class="ml-auto" style="min-width: 110px;">									
                <el-radio-group v-model="showtype" size="small">
                    <el-radio-button size="small" label="IDR">IDR</el-radio-button>
                    <el-radio-button size="small" label="USD">USD</el-radio-button>
                </el-radio-group>
            </div>
        </div>
        <BarChart v-loading.body="loading.chart" :data="chartdata" :width="barChartSizeTop.width" :height="330"/>
    </div>
</template>

<script>
import Treasury from '@/components/page/Treasury.js'
import BarChart from '@/components/chart/BarChart.js'
import { Rainbow, Rainbow3, Penanggalan, AppColors, Config, AxiosWithJar } from '@/utility.js'
//import { BalancePosition } from '@/data/treasury/BalancePosition.js'

export default {
    extends: Treasury,
    components:{ BarChart },
    props: {
        id: {
            type: String,
            default: '',
            //required: false,
        }
    },
    setup() {
        
    },
    mounted() {
        //this.setBalancePositionData()
        this.getData()
    },
    data() {
        return {
            resultdata: [],
            chartdata: [],
            title: 'POSISI SALDO PER ' + Penanggalan().sekarang,
            barChartSize: {
				width:500,
				height:500,
			},
			barChartSizeTop: {
				width:500,
				height:200,
			},
            loading: {
                chart: false,
                table: false,
            },
            showtype: 'IDR',
        }
    }, 
    watch: {
        showtype() {
            if(this.showtype =='IDR') 
                this.chartdata = this.processBarChart(this.resultdata.idr, "Label", "", "Nilai", false, "MonthName", "", 1, 2, AppColors, "Grup", [1], true)
            else
                this.chartdata = this.processBarChart(this.resultdata.usd, "Label", "", "Nilai", false, "MonthName", "", 1, 2, AppColors, "Grup", [1], true)
        }
    },
    methods: {
		setBalancePositionData() {
			//this.chartdata = this.processBarChart(BalancePosition, "TitleName", "", "Nilai", false, "MonthName", "", 1, 2, AppColors, "Grup", [1], true)
		},
        async getData() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/v1/treasury/posisisaldo?'

			//this.urlRequestParams+='&date-range-start='+ (this.dateRange && this.dateRange[0] ? this.dateRange[0] : '')
			//this.urlRequestParams+='&date-range-end='+ (this.dateRange && this.dateRange[1] ? this.dateRange[1] : '')
			//this.urlRequestParams+='&tahun='+this.year
//
			this.loading.table = true;
			this.loading.chart = true;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
                    this.resultdata = response.data.data.data;
					let balanceData = response.data.data.data.idr;
					this.title = response.data.data.title.toUpperCase();
                    this.chartdata = this.processBarChart(balanceData, "Label", "", "Nilai", false, "MonthName", "", 1, 2, AppColors, "Grup", [1], true)
                    //console.log(JSON.stringify(balanceData));
                })
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.chart = false;
					this.loading.table = false;
				})

        },
    }
}
</script>

<style>

</style>